// File: src/components/registration/steps/claimsSteps/ClaimsStep1Intro.jsx
import React from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../../../../systemUtils/MultiStyleButton";

const ClaimsStep1Intro = ({ setCardStep }) => (
  <>
    <h1 className="card-title step1-title">Claims System</h1>
    <p className="card-subtitle step1-subtitle">
      Claims are requests for payment to be made to a registered supplier.
      Manage and approve payment claims linked to suppliers using this system.
    </p>
    <div className="continue-button-container">
      <MultiStyleButton
        label="Continue"
        buttonType="approve"
        onClick={() => setCardStep(2)}
      />
    </div>
  </>
);

ClaimsStep1Intro.propTypes = {
  setCardStep: PropTypes.func.isRequired,
};

export default ClaimsStep1Intro;
